module.exports = __webpack_public_path__ + "media/images/pc/stores/common/icon_man-9ea4dd71b45b84fd8dd9e4497fefc913.png";